exports.IDS = {
  // IMG_URL: "http://192.168.16.58:8080/",
  IMG_URL: "https://pstadmin.profcymadev.in/public/",
  // IMG_URL: "https://ots.profcymadev.in/",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  users: {
    admin: 1,
    builder: 2,
    customer: 3,
  },

  usersrole: {
    admin: "Admin",
    builder: "Builder",
    customer: "Customer",
  },

  legal_verification_status: {
    process: 1,
    approved: 2,
    rejected: 3,
  },

  USER_TYPES: {
    CUSTOMER: "customer",
    VENDOR: "vendor",
    EXPERT: "expert",
  },
};
